module.exports = __webpack_public_path__ + "img/file.b1629b11.svg";